import React, { forwardRef } from "react";
import { Row, Col } from "antd";
import DynamicItem from "../../../components/forms/DynamicItem";
import { FormattedMessage } from "react-intl";
import Date from "../../../components/tables/Date";
import ChildAge from "../../../components/tables/ChildAge";
import Gender from "../../../components/tables/Gender";
import YesNoSelect from "../../../components/tables/YesNoSelect";
import Surface from "../../../components/layouts/Surface";
import FormHeader from "../../../components/forms/FormHeader";
import { ReactComponent as ChildImg } from "../../../assets/no-child-info.svg";
import moment from "moment";

const Form101Children = forwardRef((props, ref) => {
  const disabledStartDate = (current) => {
    return current && current > moment();
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }} ref={ref}>
      <Surface>
        <FormHeader title={<FormattedMessage id="app.employees.children" />} />
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <DynamicItem
              resource={"employees"}
              action={"editor"}
              emptyImg={<ChildImg />}
              name="children"
              category="employee"
              addText={<FormattedMessage id="app.employees.addChildBtn" />}
              tableItems={[
                {
                  title: "name",
                  type: "input",
                  required: true,
                },
                {
                  title: "local_id",
                  type: "input",
                  required: true,
                  localId: true,
                },
                {
                  title: "birthday",
                  type: "date",
                  required: true,
                  render: Date,
                  columnProps: { format: "L" },
                  disabledDate: disabledStartDate,
                },
                {
                  title: "age",
                  responsive: ["xl"],
                  render: ChildAge,
                  columnProps: { field: "birthday" },
                  width: "100px",
                  sortIndex: "birthday",
                  sorter: true,
                },
                {
                  title: "gender_id",
                  type: "radio",
                  required: true,
                  gender: true,
                  render: Gender,
                  translated: true,
                },
                {
                  title: "live_with_employee",
                  type: "select",
                  yesNo: true,
                  render: YesNoSelect,
                },
              ]}
            />
          </Col>
        </Row>
      </Surface>
    </div>
  );
});

export default Form101Children;
